import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { offlineDb } from '@/lib/offlineDb';
import { pdvService } from '../services/pdvService';

const CACHE_KEY = 'pdv-cache-atualizado';

export function usePdvOfflineCache(empresaId: number, enabled: boolean) {
  const [cacheAtualizado, setCacheAtualizado] = useState<string | null>(null);

  useEffect(() => {
    offlineDb.obterConfig<string>(CACHE_KEY).then(v => setCacheAtualizado(v ?? null));
  }, []);

  // Produtos frequentes
  const { data: produtosFrequentes } = useQuery({
    queryKey: ['pdv-produtos-frequentes', empresaId],
    queryFn:  () => pdvService.obterProdutosFrequentes(empresaId, 200),
    enabled:  enabled && navigator.onLine,
    staleTime: 5 * 60_000,
  });

  // Clientes recentes
  const { data: clientesRecentes } = useQuery({
    queryKey: ['pdv-clientes-recentes', empresaId],
    queryFn:  () => pdvService.obterClientesRecentes(empresaId, 100),
    enabled:  enabled && navigator.onLine,
    staleTime: 5 * 60_000,
  });

  // Salva no IndexedDB quando os dados chegam
  useEffect(() => {
    if (!produtosFrequentes?.length) return;
    const agora = new Date().toISOString();
    offlineDb.salvarProdutosCache(
      produtosFrequentes.map(p => ({ id: p.id, dados: p, dtCache: agora }))
    ).then(() => {
      offlineDb.salvarConfig(CACHE_KEY, agora);
      setCacheAtualizado(agora);
    });
  }, [produtosFrequentes]);

  useEffect(() => {
    if (!clientesRecentes?.length) return;
    const agora = new Date().toISOString();
    offlineDb.salvarClientesCache(
      clientesRecentes.map(c => ({ id: c.id, dados: c, dtCache: agora }))
    );
  }, [clientesRecentes]);

  return { cacheAtualizado };
}
